import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ActiveTab, AssistantState, PendingPrompt } from "./definitions";

const initialState: AssistantState = {
  isOpen: false,
  pendingPrompt: null,
  activeTab: null,
  pendingAttachmentToken: null,
};

export const assistantSlice = createSlice({
  name: "assistant",
  initialState,
  reducers: {
    setAssistantOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    setPendingPrompt: (state, action: PayloadAction<PendingPrompt | null>) => {
      state.pendingPrompt = action.payload;
    },
    setActiveTab: (state, action: PayloadAction<ActiveTab>) => {
      state.activeTab = action.payload;
      if (action.payload === null) {
        state.pendingPrompt = null;
      }
    },
    setPendingAttachmentToken: (
      state,
      action: PayloadAction<number | null>,
    ) => {
      state.pendingAttachmentToken = action.payload;
    },
  },
});

export const {
  setAssistantOpen,
  setPendingPrompt,
  setActiveTab,
  setPendingAttachmentToken,
} = assistantSlice.actions;

export default assistantSlice.reducer;
